module.exports = __webpack_public_path__ + "static/img/manual-45.9e4e878.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/vi/mobile/manual-45.png
// module id = kYth
// module chunks = 4